import { IOnlineApprovalTimeEntry } from './online-approval-time-entry.model';

export interface Timesheet {
    showCostCenters: boolean;
}
export interface TimesheetPackage {
    timesheet: Timesheet;
    costCenters: CostCenter[];
    onlineApprovalTimeEntries: IOnlineApprovalTimeEntry[];
}

export interface CostCenter {
    costCenterId: string;
    costCenterName: string;
    costCenterCode: string;
    isDefault: boolean;
}

export enum TimesheetRelatedEntity {
    OnlineApprovalTimeEntry = 'OnlineApprovalTimeEntry',
    CostCenters = 'CostCenters',
}
